import { Grid } from "@mui/material";
import {  useEffect, useMemo, useState } from "react";
import { useTranslation } from "react-i18next";
import FilterTable from "../../components/table/FilterTable";
import DefaultPageWrapper from "../../components/wrapper/DefaultPageWrapper";
import LoaderWrapper from "../../components/wrapper/LoaderWrapper";
import usePaginationWithSearchParams from "../../hooks/usePaginationWithSearchParams";
import { useLeadAggregation } from "../../services/leadsService";
import TableService from "../../services/tableService";
import { LEADS_TABLE_NAME, useLeadsTableFieldsConfig } from "../LeadsPage/LeadsPageTableConfig";
import LeadReportsNavigationBar from "../BaseLeadChartPage/LeadChartsNavigationBar";
import LeadChartToolBar from "../BaseLeadChartPage/LeadChartToolBar";
import { useAccessControl } from "../../hooks/auth/useCheckPermission";
import { USER_ROLES } from "../../helpers/constants";
import { useLeadsAggregationTableFieldsConfig } from "./LeadsAggregationTableFieldsConfig";
import { useLegendDialogTableData } from "../LeadChannelEfficiencyReportPage/useLegendDialogTableData";


export default function LeadChannelEfficiencyReportPage(props) {
    const { hasAccess } = useAccessControl([USER_ROLES.SALES_MARKETING, USER_ROLES.ADMIN]);

    if (!hasAccess) {
        return null;
    }

    const LEADS_TABLE_FIELDS_CONFIG = useLeadsTableFieldsConfig();
    const LEADS_AGGREGATION_TABLE_FIELDS_CONFIG = useLeadsAggregationTableFieldsConfig();

    const { t } = useTranslation();

    const [dataLocal, setDataLocal] = useState([]);
    const [recordsCount, setRecordsCount] = useState(0);
    const [hiddenColumnsForTables, setHiddenColumnsForTables] = useState([]);
    const [columnsOrdersForTables, setColumnsOrdersForTables] = useState([]);
    const [leadAggregation, setLeadAggregation] = useState()

    const {
        resetPageNumber,
        searchParams,
        setSearchParams,
        page: dataPage,
        pageSize: dataPageSize,
        handleChangePageWithSearchParams: handleChangeDataPage,
        handleChangePageSizeWithSearchParams: handleChangeDataPageSize,
    } = usePaginationWithSearchParams();

    const leadDataExportHeaders = useMemo(() => {
        return TableService.getTableExportHeaders(
            LEADS_TABLE_FIELDS_CONFIG, // @ts-ignore
           [],
           []
        );
    }, [
        LEADS_TABLE_FIELDS_CONFIG,
    ]);

    const leadDataAggregationExportHeaders = useMemo(() => {
        return TableService.getTableExportHeaders(
            LEADS_AGGREGATION_TABLE_FIELDS_CONFIG, // @ts-ignore
           [],
           []
        );
    }, [
        LEADS_AGGREGATION_TABLE_FIELDS_CONFIG,
    ]);

    const { data: leadsRows, refetch, isLoading } = useLeadAggregation(searchParams);
    useEffect(() => {
        if (leadsRows?.results) {
            setDataLocal(leadsRows.results);
            setRecordsCount(leadsRows.count);
            setLeadAggregation(leadsRows.lead_aggregation)
        }
    }, [leadsRows, dataPage, dataPageSize]);

    const data = useMemo(
        () =>
            TableService.getPreparedDataForCollapsibleTable(
                LEADS_TABLE_FIELDS_CONFIG,
                dataLocal, // @ts-ignore
                hiddenColumnsForTables?.[LEADS_TABLE_NAME]
                    ? // @ts-ignore
                      hiddenColumnsForTables?.[LEADS_TABLE_NAME]
                    : [], // @ts-ignore
                // onClickButton
                columnsOrdersForTables?.[LEADS_TABLE_NAME]
                    ? // @ts-ignore
                      columnsOrdersForTables?.[LEADS_TABLE_NAME]
                    : [],
            ),
        [
            LEADS_TABLE_FIELDS_CONFIG,
            dataLocal,
            hiddenColumnsForTables,
            columnsOrdersForTables,
            // onClickButton
        ],
    );

    const leadAggregationData = useMemo(
        () =>
            TableService.getPreparedDataForCollapsibleTable(
                LEADS_AGGREGATION_TABLE_FIELDS_CONFIG,
                leadAggregation, // @ts-ignore
                [],
                []
            ),
        [
            LEADS_AGGREGATION_TABLE_FIELDS_CONFIG,
            leadAggregation,
        ],
    );

    const legendDialogTableData = useLegendDialogTableData()
    console.log("tableData", legendDialogTableData)

    useEffect(() => {
        refetch();
    }, [searchParams]);

    if (!leadAggregation) {
        return <LoaderWrapper showLoader={true}></LoaderWrapper>
    }
   
    return (
        // @ts-ignore
        <DefaultPageWrapper tagTitle={t("headers.lead_reports")}>
            <Grid
                item
                container
                direction="row"
                justifyContent="flex-start"
                alignItems="center"
                rowSpacing={1}
            >
                <Grid item xs={12}>
                    <LeadReportsNavigationBar />
                </Grid>
                <Grid item xs={12}>
                    <LeadChartToolBar pageName={props.pageName} showLegendButton={true} legendDialogTableData={legendDialogTableData}/>
                </Grid>
                <Grid item xs={12} sx={{marginBottom: 1}}>
                    <FilterTable
                        // @ts-ignore
                        data={leadAggregationData}
                        countRecords={leadAggregation?.length}
                        style={{ maxHeight: "60vh" }}
                        headersConfig={TableService.orderColumns(
                            TableService.hideHiddenColumns(
                                LEADS_AGGREGATION_TABLE_FIELDS_CONFIG, // @ts-ignore
                                []
                            ), // @ts-ignore
                            []
                        )}
                        showCleanFilterIcon={false}
                        showContextMenu={false}
                        showExportToFileButton={true}
                        withPagination={false}
                        exportToFileUrl={"sales/leads/lead_aggregation/export/"}
                        exportToFileSearchParams={searchParams}
                        exportToFileHeaders={leadDataAggregationExportHeaders}
                        exportToFileFileName={`${t("lead.exportFileName")}.xlsx`}
                        showDetailsIcon={false}
                        showCheckbox={false}
                        page={dataPage}
                        onPageChange={handleChangeDataPage}
                        rowsPerPage={dataPageSize}
                        onRowsPerPageChange={handleChangeDataPageSize}
                        setDataLocal={setDataLocal}
                        hideFiltersIconCol={true}
                        isLoading={isLoading}
                    />
                    </Grid>
                <Grid item xs={12}>
                    <FilterTable
                        // @ts-ignore
                        data={data}
                        countRecords={recordsCount}
                        resetPageNumber={resetPageNumber}
                        style={{ maxHeight: "60vh" }}
                        headersConfig={TableService.orderColumns(
                            TableService.hideHiddenColumns(
                                LEADS_TABLE_FIELDS_CONFIG, // @ts-ignore
                                hiddenColumnsForTables?.[LEADS_TABLE_NAME]
                                    ? // @ts-ignore
                                        hiddenColumnsForTables?.[LEADS_TABLE_NAME]
                                    : [],
                            ), // @ts-ignore
                            columnsOrdersForTables?.[LEADS_TABLE_NAME]
                                ? // @ts-ignore
                                    columnsOrdersForTables?.[LEADS_TABLE_NAME]
                                : [],
                        )}
                        showCleanFilterIcon={true}
                        showContextMenu={false}
                        showExportToFileButton={true}
                        exportToFileUrl={"sales/leads/export/"}
                        exportToFileSearchParams={searchParams}
                        exportToFileHeaders={leadDataExportHeaders}
                        exportToFileFileName={`${t("lead.exportFileName")}.xlsx`}
                        showDetailsIcon={false}
                        showCheckbox={false}
                        page={dataPage}
                        onPageChange={handleChangeDataPage}
                        rowsPerPage={dataPageSize}
                        onRowsPerPageChange={handleChangeDataPageSize}
                        setDataLocal={setDataLocal}
                        hideFiltersIconCol={true}
                        isLoading={isLoading}
                    />
                </Grid>
            </Grid>
        </DefaultPageWrapper>
    );
}
